import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useCallback } from 'react';

import { ErrorResponse } from '../api/hscan';
import {
  RequestOnlinePaymentConsentBody,
  requestOnlinePaymentConsent,
  verifyOnlinePaymentConsent,
  OnlinePayment,
} from '../api/hscan/onlinePaymentConsent';

import { MutationOption } from './react-query-type';

export const useRequestOnlinePaymentConsent = (
  options?: MutationOption<
    RequestOnlinePaymentConsentBody,
    OnlinePayment,
    AxiosError<ErrorResponse>
  >,
) => {
  const fetch = useCallback(async (body: RequestOnlinePaymentConsentBody) => {
    const { data } = await requestOnlinePaymentConsent(body);
    return data;
  }, []);

  return useMutation({ mutationFn: fetch, ...options });
};

export const useVerifyOnlinePaymentConsent = (
  options?: MutationOption<string, void, AxiosError<ErrorResponse>>,
) => {
  const fetch = useCallback(async (paymentId: string) => {
    await verifyOnlinePaymentConsent({ paymentId });
  }, []);

  return useMutation({ mutationFn: fetch, ...options });
};
